/**
 * Constantes globales de l'application
 * 
 * Note: Si vous modifiez APP_NAME, n'oubliez pas de mettre à jour également :
 * - frontend/public/index.html (balise <title>)
 * - frontend/public/manifest.json (champs "short_name" et "name")
 */

export const APP_NAME = 'Libranize';

